import { render, staticRenderFns } from "./ScheletonComunityGameCard.vue?vue&type=template&id=ec0b1524&"
import script from "./ScheletonComunityGameCard.vue?vue&type=script&lang=js&"
export * from "./ScheletonComunityGameCard.vue?vue&type=script&lang=js&"
import style0 from "./ScheletonComunityGameCard.vue?vue&type=style&index=0&id=ec0b1524&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports